import { useState } from "react";
import { ChunkRead, OrgCategory } from "../../generated/core-api";
import { getPayrollAgenticAPI } from "../../generated/core-api";

const api = getPayrollAgenticAPI();

export const useChunkExpansion = (
  orgCategory: OrgCategory,
  orgId: string,
  docId: string,
  chunkId: string
) => {
  const [expanded, setExpanded] = useState(false);
  const [chunkData, setChunkData] = useState<ChunkRead | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleExpand = async () => {
    if (!expanded && !chunkData) {
      try {
        setIsLoading(true);
        setError(null);
        const chunk = await api.getChunk(orgCategory, orgId, docId, chunkId);
        setChunkData(chunk);
      } catch (err) {
        console.error("Failed to fetch chunk:", err);
        setError("Failed to load chunk content");
      } finally {
        setIsLoading(false);
      }
    }
    setExpanded(!expanded);
  };

  return {
    expanded,
    chunkData,
    isLoading,
    error,
    handleExpand,
  };
};
